<ng-template #topMenu>
  <ul>
    <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
      <a i18n="@@home-menu" routerLink="/">Home</a>
    </li>
    <li routerLinkActive="active" *ngIf="appService.indexData && appService.indexData.attributes.ShowCatalog"
      [routerLinkActiveOptions]="{exact: true}">
      <a [routerLink]="[ '/catalog',1192]" i18n="@@catalog-menu" routerLinkActive="active">Catalog</a>
    </li>
    <ng-container *ngIf="pageList">
      <li *ngFor="let page of getMenuPages(true)" [ngClass]="page.attributes.child_pages.data ? 'dropdown': ''"
        routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        <a *ngIf="!page.attributes.parent_page.data"
          [routerLink]="['/uni-page', page.attributes.SysName]">{{page.attributes.Title}}
          <i *ngIf="page.attributes.child_pages.data.length > 0" class="fa fa-chevron-down"></i>
        </a>


        <ul *ngIf="page.attributes.child_pages.data">
          <li *ngFor="let innerPage of page.attributes.child_pages.data" routerLinkActive="active"
            [ngClass]="page.attributes.child_pages.data ? 'dropdown': ''" [routerLinkActiveOptions]="{exact: false}">
            <a [routerLink]="['/uni-page', innerPage.attributes.SysName]">{{innerPage.attributes.Title}}
              <i *ngIf="innerPage.attributes.child_pages.data.length > 0" class="fa fa-chevron-right"></i>
            </a>
            <ul *ngIf="innerPage.attributes.child_pages.data">
              <li *ngFor="let innerInnerPage of innerPage.attributes.child_pages.data" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: false}">
                <a [routerLink]="['/uni-page', innerInnerPage.attributes.SysName]">{{innerInnerPage.attributes.Title}}
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ng-container>
    <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
      <a i18n="@@contacts-menu" routerLink="/contacts">Contacts</a>
    </li>
  </ul>
</ng-template>
<ng-template #topMobile>
  <ul>
    <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
      <a i18n="@@home-menu-bottom" routerLink="/">Home</a>
    </li>
    <li routerLinkActive="active" *ngIf="appService.indexData && appService.indexData.attributes.ShowCatalog"
      [routerLinkActiveOptions]="{exact: true}">
      <a [routerLink]="[ '/catalog',1192]" i18n="@@catalog-menu-bottom" routerLinkActive="active">Catalog</a>
    </li>
    <ng-container *ngIf="pageList">
      <li *ngFor="let page of getMenuPages(true)" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        <a [routerLink]="['/uni-page', page.attributes.SysName]">{{page.attributes.Title}}</a>
      </li>
    </ng-container>
    <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
      <a routerLink="/contacts" i18n="@@contacts-menu-bottom">Contacts</a>
    </li>
  </ul>
</ng-template>

<div class="mobile-nav d-lg-none">
  <ng-container *ngTemplateOutlet="topMobile"></ng-container>
</div>
<ng-container>

  <!-- ======= Header ======= -->

  <header id="header" class="fixed-top ">
    <div class="container pb-2 pl-2">
      <div class="row">
        <div class="col-3 d-none d-lg-block">

          <a *ngIf="appService.indexData && appService.indexData.attributes.Logo.data" [routerLink]="[ '/']">
            <img [src]="appService.baseUrl + appService.indexData.attributes.Logo.data.attributes.url"
              [alt]="appService.indexData.attributes.Logo.data.attributes.alternativeText"
              style="max-height: 70px; max-width: 250px;">
          </a>

        </div>

        <div class="col-12 align-self-center col-lg-7  pr-5">
          <div class="pr-2"
            *ngIf="router.url != '/' && router.url.indexOf('/search') < 0 && appService.indexData && appService.indexData.attributes.ShowCatalog">
            <app-search-view (searchEmit)="search($event)"></app-search-view>
          </div>
        </div>
        <div *ngIf="appService.indexData" class="col-3 col-lg-2 align-self-center d-none pr-0 d-lg-block">
          <div class="margin-up float-right" [innerHTML]="this.sanitizer
          .bypassSecurityTrustHtml(appService.indexData.attributes.HeaderRightCol)">
          </div>
        </div>
      </div>

    </div>
    <div class="main-bg-color d-flex">
      <nav id="navbar" class="nav-menu mx-auto">
        <div class=" text-uppercase  navbar py-1 d-none d-lg-block">
          <ng-container>
            <ng-container *ngTemplateOutlet="topMenu"></ng-container>
          </ng-container>
        </div>
      </nav>
    </div>
  </header><!-- End Header -->

  <!-- ======= Hero Section ======= -->
  <div *ngIf="appService.indexData" [ngClass]="pageList && getMenuPages(true).length > 1 ? 'pt-5' : ''"
    class="min-vh-100">
    <section id="hero" *ngIf="router.url == '/'">
      <div id="heroCarousel" class="carousel slide carousel-fade" data-ride="carousel">

        <ol class="carousel-indicators" id="hero-carousel-indicators"></ol>

        <div class="carousel-inner" role="listbox">

          <!-- carousel -->

          <div *ngFor="let carousel of appService.indexData.attributes.Carousel.data; let indexOfelement=index;"
            class="carousel-item {{ indexOfelement == 0 ? 'active': '' }}"
            style="background-image: url('{{ appService.baseUrl + carousel.attributes.url }}')">
            <div class="carousel-container">

              <div class="container">
                <h1 class="text-white"> {{ appService.indexData.attributes.Title }} </h1>
                <p class=""> {{ appService.indexData.attributes.Description }} </p>
                <div *ngIf="appService.indexData && appService.indexData.attributes.ShowCatalog" class="mb-3">
                  <app-search-view (searchEmit)="search($event)"></app-search-view>
                </div>
                <a routerLink="/contacts" i18n="@@contact-us" class="btn-get-started scrollto">Contact Us</a>
              </div>
            </div>
          </div>

        </div>

        <a class="carousel-control-prev" href="#heroCarousel" role="button" data-slide="prev">
          <span class="carousel-control-prev-icon icofont-simple-left" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>

        <a class="carousel-control-next" href="#heroCarousel" role="button" data-slide="next">
          <span class="carousel-control-next-icon icofont-simple-right" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
        </a>

      </div>
    </section><!-- End Hero -->

    <main id="main">
      <div class="container">
        <router-outlet></router-outlet>
      </div>

    </main><!-- End #main -->
  </div>
  <!-- ======= Footer ======= -->
  <footer *ngIf="appService.indexData" id="footer">
    <div class="footer-top">
      <div class="container">
        <div class="row">

          <div class="col-lg-3 col-md-6">
            <div class="footer-info" [innerHTML]="appService.indexData.attributes.FooterLeftCol">
            </div>
          </div>

          <div class="col-lg-2 col-md-6 footer-links">
            <h4 i18n="@@menu">Menu</h4>
            <ul>
              <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                <a i18n="@@home-menu-bottom" routerLink="/">Home</a>
              </li>
              <li routerLinkActive="active" *ngIf="appService.indexData && appService.indexData.attributes.ShowCatalog"
                [routerLinkActiveOptions]="{exact: true}">
                <a [routerLink]="[ '/catalog',1192]" i18n="@@catalog-menu-bottom" routerLinkActive="active">Catalog</a>
              </li>
              <ng-container *ngIf="pageList">
                <li *ngFor="let page of getMenuPages(false)" routerLinkActive="active"
                  [routerLinkActiveOptions]="{exact: true}">
                  <a [routerLink]="['/uni-page', page.attributes.SysName]">{{page.attributes.Title}}</a>
                </li>
              </ng-container>
              <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                <a routerLink="/contacts" i18n="@@contacts-menu-bottom">Contacts</a>
              </li>
            </ul>
          </div>

          <div class="col-lg-3 col-md-6 footer-links">
            <div *ngIf="appService.indexData.attributes.FooterMidCol"
              [innerHTML]="this.sanitizer.bypassSecurityTrustHtml(appService.indexData.attributes.FooterMidCol)">
            </div>
          </div>
          <div class="col-lg-4 col-md-6 footer-newsletter">
            <div *ngIf="appService.indexData.attributes.FooterRightCol"
              [innerHTML]="this.sanitizer.bypassSecurityTrustHtml(appService.indexData.attributes.FooterRightCol)">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="copyright">
        <span i18n="@@copyright-start">Copyright</span> {{ appService.indexData.attributes.HeaderTitle}} <span
          i18n="@@copyright-end">All Rights Reserved.</span>
      </div>

    </div>
  </footer><!-- End Footer -->

  <a href="javascript:;" onclick="$('html, body').animate({scrollTop:0}, '300');" class="back-to-top"><i
      class="icofont-simple-up"></i></a>
</ng-container>